<section
  class="self-inspection-wrapper"
  [ngClass]="{ 'warning-border': showWaring }"
>
  @if (isLoading$ | async) {
    <app-loading-self-inspection />
  }
  <div class="text-container">
    @if (data.completed) {
      <gc-text
        [variant]="'informationBold'"
        [textColor]="data.isNotApplicableComment ? 'critical' : 'success'"
        >{{ (completedString | translate) + completeInfoString }}</gc-text
      >
    }
    @if (data.subSection) {
      <gc-text
        class="version-text"
        [variant]="'information'"
        [textColor]="'secondary'"
        >{{ data.subSection }}</gc-text
      >
    }
  </div>

  @if (!isEditMode && !data.isNotApplicableComment) {
    <ng-content />
  } @else {
    <app-not-applicable
      [comment]="data.isNotApplicableComment"
      [sectionDescription]="data.description"
      [isEditMode]="isEditMode"
      [id]="data.id"
      (markAsNA)="handleMarkAsNA($event)"
      (cancel)="handleCancelEditMode()"
    />
  }

  @if (data.instructionalImage) {
    <app-image-instruction [imageUrl]="data.instructionalImage" />
  }
</section>
